/// <amd-module name="SuiteCommerce.PagePrinter.ExtQRCode.BitBuffer"/>
define("SuiteCommerce.PagePrinter.ExtQRCode.BitBuffer", ["require", "exports"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var BitBuffer = /** @class */ (function () {
        function BitBuffer() {
            this.buffer = [];
            this.size = 0;
        }
        BitBuffer.prototype.get = function (index) {
            var bufIndex = Math.floor(index / 8);
            return ((this.buffer[bufIndex] >>> (7 - (index % 8))) & 1) == 1;
        };
        BitBuffer.prototype.put = function (num, length) {
            for (var i = 0; i < length; i++) {
                this.putBit(((num >>> (length - i - 1)) & 1) == 1);
            }
        };
        BitBuffer.prototype.getSizeInBits = function () {
            return this.size;
        };
        BitBuffer.prototype.putBit = function (bit) {
            var bufIndex = Math.floor(this.size / 8);
            if (this.buffer.length <= bufIndex) {
                this.buffer.push(0);
            }
            if (bit) {
                this.buffer[bufIndex] |= 0x80 >>> this.size % 8;
            }
            this.size++;
        };
        return BitBuffer;
    }());
    exports.BitBuffer = BitBuffer;
});
